import React from 'react';

// Button component with enhanced styling
const Button = ({ 
  children, 
  className = '', 
  variant = 'primary', 
  size = 'md',
  onClick,
  disabled = false,
  type = 'button',
  href
}) => {
  // Base classes
  const baseClasses = "inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-indigo-500 disabled:opacity-50 button-glow";
  
  // Size classes
  const sizeClasses = {
    sm: "h-9 px-3 text-sm",
    md: "h-10 px-4",
    lg: "h-11 px-6 text-lg"
  };
  
  // Variant classes
  const variantClasses = {
    primary: "bg-gradient-to-b from-indigo-500 to-indigo-600 text-white hover:from-indigo-600 hover:to-indigo-700 shadow-lg shadow-indigo-500/20",
    secondary: "bg-gray-800/80 backdrop-blur-sm text-white hover:bg-gray-700/80 border border-gray-700/50",
    outline: "border border-gray-700 bg-transparent hover:bg-gray-800/50 text-gray-200",
    ghost: "bg-transparent hover:bg-gray-800/50 text-gray-200",
    success: "bg-gradient-to-b from-green-500 to-green-600 text-white hover:from-green-600 hover:to-green-700 shadow-lg shadow-green-500/20"
  };

  const handleClick = (e) => {
    if (href) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    if (onClick) {
      onClick(e);
    }
  };
  
  return (
    <button
      className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${className}`}
      onClick={handleClick}
      disabled={disabled}
      type={type}
    >
      {children}
    </button>
  );
};

export default Button;
